/**
 * PAISA HANDLING - ek hi jagah.
 *
 * ⚠️ Backend ab SAARA paisa PAISE mein bhejta hai (Long).
 *    ₹500 = 50000
 *
 * Pehle backend rupees bhejta tha (Double). Ab nahi. Isliye har
 * jagah jahan amount dikhta hai, formatPaise() lagana ZAROORI hai -
 * warna user ko "₹50000" dikhega jab asal mein ₹500 hai.
 *
 * Aur jahan user amount TYPE karta hai (poojari apni price
 * daalta hai), wahan toPaise() lagana zaroori hai - warna ₹500
 * backend mein 500 paise = ₹5 ban jayega.
 *
 * ⚠️ Yahan kabhi float math mat karna. Paise integer hain.
 */

/**
 * Paise ko dikhane layak rupees mein badlo.
 *
 *   formatPaise(50000)  -> "₹500"
 *   formatPaise(50050)  -> "₹500.50"
 *   formatPaise(0)      -> "₹0"
 *   formatPaise(null)   -> "₹0"
 *
 * Poore rupees hain to decimal nahi dikhate - "₹500" saaf lagta
 * hai, "₹500.00" bhaari lagta hai. Paise hain tabhi dikhate hain.
 */
export const formatPaise = (paise) => {
  if (paise === null || paise === undefined || isNaN(paise)) {
    return '₹0';
  }

  const n = Math.round(Number(paise));
  const rupees = Math.floor(Math.abs(n) / 100);
  const p = Math.abs(n) % 100;
  const sign = n < 0 ? '-' : '';

  // Indian comma format: 1,00,000 (lakh) - western 100,000 nahi
  const formatted = rupees.toLocaleString('en-IN');

  return p === 0
    ? `${sign}₹${formatted}`
    : `${sign}₹${formatted}.${String(p).padStart(2, '0')}`;
};

/**
 * Paise ko sirf number mein badlo - bina ₹ ke.
 * Jahan symbol alag se dikhana ho.
 *
 *   paiseToRupees(50000) -> 500
 *   paiseToRupees(50050) -> 500.5
 */
export const paiseToRupees = (paise) => {
  if (paise === null || paise === undefined || isNaN(paise)) {
    return 0;
  }
  return Math.round(Number(paise)) / 100;
};

/**
 * User ne jo rupees type kiye, unhe paise mein badlo.
 *
 *   toPaise(500)     -> 50000
 *   toPaise("500")   -> 50000
 *   toPaise(500.50)  -> 50050
 *   toPaise("")      -> 0
 *
 * ⚠️ Math.round ZAROORI hai. JavaScript mein 500.1 * 100 =
 * 50009.999999999996 hota hai. Bina round ke wo paisa kho jaata
 * hai ya ek extra paisa aa jaata hai.
 */
export const toPaise = (rupees) => {
  if (rupees === null || rupees === undefined || rupees === '') {
    return 0;
  }
  const n = Number(rupees);
  if (isNaN(n)) {
    return 0;
  }
  return Math.round(n * 100);
};

/**
 * Amount valid hai ya nahi - form validation ke liye.
 *
 * @param rupees      user ne jo type kiya
 * @param minRupees   minimum kitna hona chahiye (default ₹1)
 * @returns error message, ya null agar sab theek hai
 */
export const validateAmount = (rupees, minRupees = 1) => {
  if (rupees === null || rupees === undefined || rupees === '') {
    return 'Please enter an amount';
  }
  const n = Number(rupees);
  if (isNaN(n)) {
    return 'Please enter a valid number';
  }
  if (n < minRupees) {
    return `Amount must be at least ₹${minRupees}`;
  }
  // Paise se chhota kuch nahi ho sakta
  if (Math.round(n * 100) !== Number((n * 100).toFixed(0))) {
    return 'Amount can have at most 2 decimal places';
  }
  return null;
};